import { Check, Copy } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { Input } from '@/shared/components/ui/input';

type ReferralLinkPanelProps = {
  referralLink?: string;
  isLoading: boolean;
  isError: boolean;
  copied: boolean;
  onCopy: () => void;
  errorMessage: string;
  emptyMessage: string;
};

export const ReferralLinkPanel = ({
  referralLink,
  isLoading,
  isError,
  copied,
  onCopy,
  errorMessage,
  emptyMessage,
}: ReferralLinkPanelProps) => {
  if (isLoading) {
    return null;
  }

  if (!referralLink) {
    return (
      <div className="mb-6 rounded-lg border border-amber-200 bg-amber-50 p-4">
        <p className="text-sm text-amber-800">
          {isError ? errorMessage : emptyMessage}
        </p>
      </div>
    );
  }

  return (
    <div className="mb-6 rounded-lg border border-gray-200 bg-gray-50 p-4">
      <div className="flex items-start gap-3">
        <div className="min-w-0 flex-1">
          <h4 className="mb-1 text-sm font-medium text-gray-900">
            Your Referral Link
          </h4>
          <p className="mb-3 text-xs text-gray-600">
            Share this link with clients to invite them to bQuest
          </p>
          <div className="flex gap-2">
            <Input
              type="text"
              value={referralLink}
              readOnly
              className="h-9 bg-white font-mono text-xs"
            />
            <Button
              onClick={onCopy}
              size="sm"
              className={`gap-1.5 ${
                copied
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-[#026857] hover:bg-[#025247]'
              }`}
            >
              {copied ? (
                <>
                  <Check className="h-3.5 w-3.5" />
                  <span className="text-xs">Copied!</span>
                </>
              ) : (
                <>
                  <Copy className="h-3.5 w-3.5" />
                  <span className="text-xs">Copy</span>
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
